const NewsList2017 = [
    {
        dt: "2017",
        my: "",
        link: "#IndianYouthDelegationtoChina",
        title: "Indian Youth Delegation to China & Russia",
        desc: ""
    },
    {
        dt: "2017",
        my: "",
        link: "#Internship",
        title: "Internships at Texas A&M University",
        desc: ""
    },
    {
        dt: "2017",
        my: "",
        link: "#agreement",
        title: "PPA with SECI",
        desc: ""
    },
    {
        dt: "2017",
        my: "",
        link: "/mou-r-b",
        title: "MoU with R&B Department",
        desc: ""
    },
    {
        dt: "2017",
        my: "",
        link: "/mou",
        title: "MoU with Venusgeo/7iq",
        desc: ""
    },
    {
        dt: "2017",
        my: "",
        link: "/inter-iit-sports-meet",
        title: "Inter IIT Sports Meet",
        desc: ""
    },
    {
        dt: "2017",
        my: "",
        link: "https://files.iittp.ac.in/images/demo/iit/pdfs/VigilanceAwarenessWeek2017.pdf",
        title: "Vigilance Awareness Week",
        desc: ""
    },
    {
        dt: "2017",
        my: "",
        link: "https://files.iittp.ac.in/images/demo/iit/pdfs/NoteonRunforUnity2017@IITTirupati.pdf",
        title: "Run for Unity",
        desc: ""
    },
    {
        dt: "2017",
        my: "",
        link: "#IndianYouthDelegationtoChina",
        title: "Indian Youth Delegation to China & Russia",
        desc: ""
    },
    {
        dt: "2017",
        my: "",
        link: "#Internship",
        title: "Internships at Texas A&M University",
        desc: ""
    },
    {
        dt: "2017",
        my: "",
        link: "/awards",
        title: "Awards",
        desc: ""
    }
];


export default NewsList2017;